export const CLEAR_SEARCHER_FILTERS_ON_SET_TABS =
  'CLEAR_SEARCHER_FILTERS_ON_SET_TABS';
